<template>
  <div
    class="tw:relative tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-[15px] tw:cursor-pointer"
    @click="$emit('click-item')"
  >
    <template v-if="!isMore">
      <div class="tw:relative tw:w-full">
        <div
          class="tw:aspect-square tw:w-full tw:min-w-[66px] tw:bg-cover tw:bg-center tw:bg-no-repeat"
          :style="{ backgroundImage: `url(${iconUrl || '/img/basic-icon/no-flag.svg'})` }"
        />
        <nuxt-img
          v-if="flag"
          :src="flag"
          alt="flag"
          width="25"
          height="25"
          class="tw:absolute! tw:-bottom-[12.5px] tw:left-1/2 tw:-translate-x-1/2 tw:size-[25px] tw:rounded-full tw:object-cover"
        />
        <div
          v-if="badge"
          class="tw:absolute! tw:-top-[9px] tw:left-1/2 tw:-translate-x-1/2 tw:whitespace-nowrap tw:rounded-[14px] tw:border tw:border-usdg-color-brand-500/20 tw:bg-white tw:px-1.5 tw:py-[3px] tw:text-[10px] tw:font-semibold tw:text-usdg-color-brand-500"
        >
          {{ badge }}
        </div>
      </div>
      <div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-0.5 tw:text-center">
        <span
          class="tw:typo-text-m tw:font-semibold tw:text-usdg-color-text-body1 tw:whitespace-pre-line"
        >
          {{ formatText(name) }}
        </span>
        <span
          v-if="description"
          class="tw:typo-text-s tw:text-usdg-color-text-subtle1 tw:font-normal"
        >
          {{ description }}
        </span>
      </div>
    </template>
    <template v-else>
      <div
        class="tw:aspect-square tw:w-full tw:min-w-[66px] tw:bg-cover tw:bg-center tw:bg-no-repeat"
        style="background-image: url(/img/main/product-all-icon.svg)"
      />
      <span class="tw:typo-text-m tw:font-semibold tw:text-usdg-color-text-body1">전체국가</span>
    </template>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    iconUrl?: string
    flag?: string
    name?: string
    badge?: string
    description?: string
    isMore?: boolean // 더보기
  }>(),
  {
    iconUrl: '',
    flag: '',
    name: '',
    badge: '',
    description: '',
    isMore: false
  }
)

defineEmits(['click-item'])

const formatText = (text: string) => {
  if (text.length < 6) {
    return text
  } else {
    return !text.includes('/') ? text.replace(/\s/g, '\n') : text.replace(/\//g, '/\n')
  }
}
</script>
